export default "__VITE_ASSET__33a0af95__"